export const AUTHORITATIVE_MARKET_COUNTS = Object.freeze({
  analyzedRiads: 184,
  districts: 43,
  underpricedRiads: 39,
});

export const MARKET_POSITIONING_LINE =
  "The Intelligence Layer for Marrakech’s Scarce Riad Market.";